import React, { useState } from "react";
import { Link } from "react-router-dom";
import { observer } from "mobx-react";
import Play from "../Icons/Play.svg";
import Pause from "../Icons/Pause.svg";
import Logo from "../../../logo-no-text.png";
// import Menu from "@material-ui/core/Menu";
// import MenuItem from "@material-ui/core/MenuItem";
// import IconButton from "@material-ui/core/IconButton";
// import MoreVertIcon from "@material-ui/icons/MoreVert";
import { Menu, MenuItem, IconButton } from "@mui/material";
import {
  MoreVert as MoreVertIcon,
} from "@mui/icons-material";
import LazyLoad from "react-lazyload";
import ShareModal from '../../../Components/ShareModal/index';

const getHostName = (link) => {
  if (link) {
    const doc = document.createElement("a");
    doc.href = (link.startsWith("http") ? "" : "http://") + link;
    return doc.hostname;
  }
};

const estimatedMinutes = (numCharacters) =>
  Math.round(((numCharacters / 900)));

const getMp3Prefix = (article) => {
  try {
    return `/share/${article.audio_url.split("/")[4].replace(".mp3", "")}`;
  } catch (e) {
    return `/404`;
  }
};

const Article = observer(
  ({ article, trackingId, addArticleToPlaylist, selectArticle, isActive }) => {
    const {
      article_id,
      title,
      date,
      date_added,
      num_characters,
      thumbnail_url,
    } = article;

    const articleDate = new Date(date || date_added);
    const [isHovering, setIsHovering] = useState(false);
    const [menuAnchorElement, setAnchorEl] = useState(null);
    const [imageLoaded, setImageLoaded] = useState(false);
    const [isShareModalOpen, setIsShareModalOpen] = useState(false);

    const onImageLoaded = () => setImageLoaded(true);

    const handleMenuClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
      setAnchorEl(null);
    };

    const shareArticle = () => {
      handleMenuClose();
      setIsShareModalOpen(true);
    };

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    return (
      <>
        <div className="article-card">
          <div
            className="article-background-img"
            style={{
              backgroundImage: `url(${imageLoaded ? thumbnail_url : Logo})`,
            }}
          />
          <div className="article">
            <div className="context-menu">
              <IconButton onClick={handleMenuClick}>
                <MoreVertIcon htmlColor="#ffffff" />
              </IconButton>
              <Menu
                anchorEl={menuAnchorElement}
                keepMounted
                open={Boolean(menuAnchorElement)}
                onClose={handleMenuClose}
              >
                <MenuItem onClick={shareArticle}>Share</MenuItem>
              </Menu>
            </div>
            <div
              className="thumbnail"
              onClick={() => selectArticle(article)}
              onMouseEnter={() => setIsHovering(true)}
              onMouseLeave={() => setIsHovering(false)}
            >
              {thumbnail_url ? (
                <LazyLoad height={145} offset={150}>
                  <img src={thumbnail_url} onLoad={onImageLoaded} />
                </LazyLoad>
              ) : null}
              <div
                style={{
                  opacity: isHovering ? 1 : 0,
                }}
                className="floating-play-icon-container"
                onClick={() => selectArticle(article)}
              >
                <img id="floating-play-icon-svg" src={isActive ? Pause : Play} />
              </div>
            </div>
            <div
              className="title"
              onClick={() => selectArticle(article)}
              onMouseEnter={() => setIsHovering(true)}
              onMouseLeave={() => setIsHovering(false)}
            >
              {title}
            </div>
            <div className="author">
              <a href={`http://${article_id}`} target="_blank" className="link">
                {getHostName(article_id)}
              </a>
              <span className="divider">|</span>{" "}
              {monthNames[articleDate.getMonth()]} {articleDate.getFullYear()}
            </div>
            <div className="time">{estimatedMinutes(num_characters)} min</div>
            {addArticleToPlaylist ? (
              <div
                className="add-to-playlist"
                onClick={(e) => {
                  addArticleToPlaylist(article);
                  e.target.innerText = "Added!";
                }}
              >
                <span>Listen Later</span>
              </div>
            ) : null}
          </div>
        </div>
        <ShareModal 
          isOpen={isShareModalOpen}
          onClose={() => setIsShareModalOpen(false)}
          article={article}
        />
      </>
    );
  }
);

export default Article;
